/**
 * ErrorRecoveryAction - Actions for error recovery
 */
export enum ErrorRecoveryAction {
    /**
     * Retry fetching the region (with exponential backoff)
     */
    RETRY = 'RETRY',

    /**
     * Skip this region and continue with others (graceful degradation)
     */
    SKIP = 'SKIP',

    /**
     * Abort the entire fetch operation and throw error
     */
    ABORT = 'ABORT'
}